import { useEnvValue, usePipeline } from '@morningtrain/react-helpers'
import React from 'react'
import useInterval from 'support/hooks/use-interval'
import { useSpawner } from '@morningtrain/react-spawner'

export default function TriggerPipelineOnInactivity () {
  const pipeline = usePipeline()
  const spawner = useSpawner()

  const [inactivityTime, setInactivityTime] = useEnvValue('inactivity_time', 0)
  const [hasTriggered, setHasTriggered] = React.useState(false)

  const secondsBeforeInactivity = 25

  useInterval(() => {
    setInactivityTime(inactivityTime + 1)

    if (!hasTriggered && inactivityTime + 1 >= secondsBeforeInactivity) {
      setHasTriggered(true)
      pipeline.trigger({ clickEvent: null }).catch(function (err) {
        return console.log('caught error', err)
      })
    }
  }, 1000)

  const resetInactivity = () => {
    if (spawner && typeof spawner.clear === 'function') {
      spawner.clear()
    }
    setInactivityTime(0)
    setHasTriggered(false)
  }

  React.useEffect(() => {
    document.addEventListener('click', resetInactivity)
    document.addEventListener('mouseover', resetInactivity)
    document.addEventListener('mousemove', resetInactivity)
    document.addEventListener('mouseup', resetInactivity)
    document.addEventListener('mousedown', resetInactivity)
    document.addEventListener('touchstart', resetInactivity)
    document.addEventListener('touchend', resetInactivity)
  }, [])

  return null
}
